// Wacht tot Zepto Product Personalizer volledig geladen is
window.addEventListener('pplrAppInitiated', function () {
    console.log("pplrAppInitiated")
    // Selecteer alle tekstvelden binnen een pplr-wrapper

    document.addEventListener('click', function(event) {
    const button = event.target.closest('.ptc_button');

    if (button) {
       inputValidate();
    }
});
        
    

    function inputValidate() {
        let textbox = document.querySelector('.pplr_text');
        const sanitizeInput = (input) => {
            return input.replace(/[^\p{L}\p{M}a-zA-Z0-9 &\-]/gu, '');
        };
        const removeEmojis = (input) => {
            const emojiRegex = /[\p{Emoji}\p{Emoji_Presentation}\p{Emoji_Modifier_Base}\p{Emoji_Modifier}\p{Emoji_Component}]/gu;
            return input.replace(emojiRegex, '');
        };

        textbox.addEventListener("input", event => {
            let currentValue = textbox.value;
            let inputWithoutEmojis = removeEmojis(currentValue);
            let sanitizedValue = sanitizeInput(inputWithoutEmojis);
            if (currentValue !== sanitizedValue) {
            textbox.value = sanitizedValue;
            }
        }, false);

        textbox.addEventListener("paste", event => {
            setTimeout(() => {
            let currentValue = textbox.value;
            let inputWithoutEmojis = removeEmojis(currentValue);
            let sanitizedValue = sanitizeInput(inputWithoutEmojis);
            if (currentValue !== sanitizedValue) {
                textbox.value = sanitizedValue;
            }
            }, 10);
        }, false);
        }

});